import type { IconData } from '@stacksjs/iconify-core'

export const natureDog: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 0a4 4 0 0 0-4 4v12h3a3 3 0 0 0 3-3a3 3 0 0 0 3 3h3V4a4 4 0 0 0-4-4v4H6zm2 13l2-2H6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureDog
